import {NgModule} from '@angular/core'
import {AsyncPipe, NgOptimizedImage} from '@angular/common'
import {TranslocoDirective} from '@ngneat/transloco'
import {RichTextModule} from '../../../shared/components/rich-text/rich-text.module'
import {RouterLink} from '@angular/router'
import {IndustryOverviewPageComponent} from './industry-overview-page.component'
import {IndustryOverviewPageRoutingModule} from './industry-overview-page-routing.module'
import {HeroCoverModule} from '../../../shared/components/hero-cover/hero-cover.module'
import {SliderModule} from '../../../craft/slider/slider.module'
import {ContactFormCardModule} from '../../../craft/contact-form-card/contact-form-card.module'
import {AuthorsModule} from '../../../shared/components/content/authors/authors.module'
import {ChipComponent} from '../../../craft/chip/chip.component'
import {ButtonModule} from '../../../craft/button/button.module'
import {StickyBottomNavigationModule} from '../../../shared/components/sticky-bottom-navigation/sticky-bottom-navigation.module'
import {ProDirectoryByIndustrySectionComponent} from '../../../shared/components/pro-directory-by-industry-section/pro-directory-by-industry-section.component'
import {BreadcrumbsModule} from '../../../craft/breadcrumbs/breadcrumbs.module'
import {KnowledgeSectionComponent} from '../../../shared/components/content/knowledge-section/knowledge-section.component'
import {CardsModule} from '../../../craft/cards/cards.module'
import {PresentationSectionComponent} from '../../../shared/components/presentation-section/presentation-section.component'
import {SupportSectionComponent} from '../../../shared/components/content/support-section/support-section.component'
import {InspirationSectionComponent} from '../../../shared/components/content/inspiration-section/inspiration-section.component'
import {PromotionalBannerSectionComponent} from '../../../shared/components/content/promotional-banner-section/promotional-banner-section.component'
import {OfferingsSectionComponent} from '../../../shared/components/content/offerings-section/offerings-section.component'
import {ContentSectionComponent} from '../../../craft/content-section/content-section.component'

@NgModule({
  declarations: [IndustryOverviewPageComponent],
  imports: [
    HeroCoverModule,
    AsyncPipe,
    NgOptimizedImage,
    BreadcrumbsModule,
    ButtonModule,
    InspirationSectionComponent,
    ProDirectoryByIndustrySectionComponent,
    AuthorsModule,
    ContentSectionComponent,
    ChipComponent,
    RichTextModule,
    ContactFormCardModule,
    PresentationSectionComponent,
    OfferingsSectionComponent,
    PromotionalBannerSectionComponent,
    KnowledgeSectionComponent,
    SliderModule,
    CardsModule,
    RouterLink,
    SupportSectionComponent,
    StickyBottomNavigationModule,
    TranslocoDirective,
    IndustryOverviewPageRoutingModule,
  ],
})
export default class IndustryOverviewPageModule {}
